import { setAxiosHeader } from "./auth";
import axios from "axios";

setAxiosHeader();

var url = process.env.VUE_APP_BK_OKAN;
var backToken = process.env.VUE_APP_BK_TOKEN;
var backPwa = process.env.VUE_APP_PWA_BACK

function Auth() {
  return {
    getApps: async (cc, loginId) => {
      return await axios.get(
        `${url}/wp-json/okanapiwp/v1/aplicativos/${cc}/${loginId}`
        // `https://admdev.okan.tools/wp-json/okanapiwp/v1/aplicativos/1032468791/9844`
      );
    },
    google: async (data) => {
      return await fetch(`${backPwa}/v1/local-auth/api/auth/google`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
          },
        body: JSON.stringify(data),
      });
    },
    // ldap: async (data) => {
    //     return await axiosInstance.post(`/auth/ldap`, JSON.stringify(data));
    // },
    ldap2: async (data) => {
      try {
        const response = await fetch(`${backPwa}/v1/local-auth/api/auth/ldap`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
    
        const resData = await response.json(); // Leer la respuesta una sola vez
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }
    
        return resData; 
    
      } catch (error) {
        console.error("Error en ldap2:", error);
        throw error; // Propagar el error para ser capturado en el .catch()
      }
    },
    currentUser: async (token) => {
        try {
          const response = await fetch(`${backPwa}/v1/local-auth/api/currentUser`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
              },
            body: JSON.stringify(token),
          });
      
          const resData = await response.json(); // Leer la respuesta una sola vez
      
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
          }
      
          return resData; 
      
        } catch (error) {
          console.error("Error en current:", error);
          throw error; // Propagar el error para ser capturado en el .catch()
        }
      },
    saveAppActivity: async (data) => {
      return await fetch(`${url}/wp-json/jet-cct/apps_mas_usadas`, {
        method: "POST",
        headers: {
          Authorization: `Basic ${backToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    },
  };
}

export default {
  Auth,
};
